angular
  .module('sms.common.filters', [])

  .filter('gradeDisplay', function (gradeService) {
    return function (value) {
      return _.result(_.find(gradeService.grades, { value }), 'display', '')
    }
  })

  .filter('age', function () {
    return function (date) {
      if (!date) return ''
      return moment().diff(date, 'years')
    }
  })

  .filter('filterByJulyAge', function () {
    return function (arr, date) {
      if (!date) return arr
      const creditDate = moment().month(6).date(1)
      if (moment().month() < 6) creditDate.subtract(1, 'year')
      const ageAsOfJuly = creditDate.diff(date, 'years')
      const isAdult = ageAsOfJuly >= 19
      return _.filter(arr, {
        adult: isAdult
      })
    }
  })
